import React from "react";
import "./servicefb.css";
import Topbar from "../../components/Topbar/Topbar";
import Footer from "../../components/Footer/Footer";
import Franchise from "../../components/Franchise/Franchise";

const ServiceFB = () => {
    return (
        <>
            <Topbar />
            <div className="servicefb-container">
                <Franchise/>
                <Footer />
            </div>
        </>
    )
}

export default ServiceFB;